'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false,
    omisePublicKey: 'pkey_test_5nll2jx5x0xuyu6agqn'
  },
  production: {
    isProduction: true,
    externalApiPath: 'https://api.takemetour.com',
    apiPath: process.env.APIPATH || 'http://production-api-service:3000',
    adminPath: 'https://admin.takemetour.com',
    nexperiencePath: process.env.NEX_PATH || 'http://production-nexperience:3000',
    dashboardPath: process.env.DASHBOARD_PATH || 'http://production-redux-dashboard:3000',
    localtablePath: process.env.LOCAL_TABLE_PATH || 'http://production-localtable:3000',
    biennalePath: process.env.BIENNALE_PATH || 'http://production-biennale:3000',
    plusplusPath: process.env.PLUSPLUS_PATH || 'http://production-plusplus-landing:3000',
    fruitMarketPath: process.env.FRUIT_MARKET_PATH || 'http://production-fruit-market-frontend:3000',
    newNexPath: process.env.NEW_NEX_PATH || 'http://production-the-next-takemetour:3000',
    socketPath: process.env.SOCKETPATH || 'http://production-socketio-service:3000/ws',
    omisePublicKey: 'pkey_527g00po5jzkzm4h82g',
    mixpanel: {
      token: 'd96aeba37ec23f947678c31da6f2078c'
    },
    mediaPath: 'https://d2d3n9ufwugv3m.cloudfront.net',
    distPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-assets',
    gaToken: 'UA-48143288-4',
    baseURL: {
      en: 'https://www.takemetour.com',
      th: 'https://pachantiew.takemetour.com',
      zh: 'https://zh.takemetour.com'
    },
    gaTokens: {
      en: 'UA-48143288-4',
      th: 'UA-48143288-6',
      zh: 'UA-48143288-7',
      au: 'UA-48143288-11'
    },
    wgProgramId: '265165',
    wgEventId: '1028995',
    uiKitAssetPath: 'https://ddhiorx9qbcay.cloudfront.net',
    letOtherJoinTrips: ['588441279da53c0011e9f112', '5b8e1e946dffd40014702de4', '5d9d57fa51bb2d0012bd2632', '5dad5a45d115da0010b1025b', '5c5bbe1e129f6c00132fce92', '5c458ab1231658001286d2e0', '580f3caba2c5e61500208e23', '5af2bc169569290011a92650', '5ccb8487bf7f3600125f9162', '592676152dee020014793b64',
    // ------- 27 Jan updated below -----
    '563a23b512ea52182881bdc1', '5764f5c967eacd13007d012e', '57dd6c5cfb3f74110048a1fd', '590dd6c115e1120011cb59a3', '5b84110227d31a0011f647d8', '5b8fcb576dffd400147033d9', '5d188f78c5959000129ab460', '5e2806a05da78f00163fad3a', '5cb072229871cd0012081fa4', '57345d7f2d8edfd735669783', '59382d6c27de220011b995eb', '56e285ca4be82a7f0017bc1e', '56d091ab4686529a0f3e622a', '56e419324be82a7f0017bee4', '56f9766e47d815010098ef6f', '5d4d1e80360b1b00124178d9', '5d8098244437af0014af8813', '5e203000deb2f20012cfa856', '5a70910533f5960010a29e2b', '5a711a1b8d75d20011336dbf', '5ac0fce8db4d210011b5ed71', '5c6973601a5f2e00130cb989', '5d727a8da543930011711df0', '5cf4e4bc091cf70011689f1f', '5bcde724d28b290012bad675', '5be159441872b00014dd10c6', '5be5b1021872b00014dd1c1d', '5bfbef235ccf0c00112f73b0', '5a75cb7833f5960010a2a5c3', '5726a7a2149e9c01009c473f', '57e4ab5ea88b5a130023c72b', '5719fed57cd26d0100aeb228', '589dc7dfbadca300117e8386', '594a668fb19800001145ef51', '576b6aeade1eda1300fe787d',
    // '5bf662035ccf0c00112f6a9c', Hansa W.
    '58a195d9badca300117e8799', '59d6da06714315000fbc7268', '5a0d23f13890a50012080312', '5a8812e3f1a9ea0013d542a3', '5b5909b2433e860016bcc8a0', '5b9b945433ea7900105bb47a', '5bfbc043d60dd90013c12452', '5bfc0943d60dd90013c1262e', '5bfca9415ccf0c00112f75fa', '5c0bf0581e62d000123e7c4e', '56bb625f1f70e0f13b3b3c19', '5718486b7cd26d0100aeaad0', '5ba0ad77254f800013082214', '5605432dc74485546f91e090', '5605467d346b522b762a5722', '5b18c83e7d9cc900115e5dcb', '59736360338a1000123d3650', '5b046b5d78666f00114efb1f', '5dce5af844e557001399483c', '5935a2b098e10d0011c8d5ce', '5b6968c92e519f0012403734',
    // '5b6a9e232e519f0012407489', Hansa W.
    // '57247a0e149e9c01009c43ab', Hansa W.
    // '5c4099434c32d900166bfd9e', Hansa W.
    '5873374308f231001003a7c2', '5e27da975da78f00163fa4b8', '5a69a140e83463001180fb30', '579ca729ccbe2d1200aefdae', '58b2a00fbadca300117ea30c', '5a644820e83463001180f463', '5b5584094009740011a5d36e', '5d4d7288360b1b00124179af', '5b420cb23e978700105044d2', '5b72760f433e860016bce267', '5b87799184f1b20012e82eca', '5bebe3421872b00014dd23f1', '583ad89e866377120087b649', '596331d0af191a0011c5ad2b', '5a73c65e33f5960010a2a2bc', '5a8bec0bf1a9ea0013d546de', '5b8a8bf81b95c60012a4f967', '5b8be68f1b95c60012a4fb38', '5c04d71516db920011532c9a', '5c04dd5e59c20700108a19a0', '5adb20ac7a783e0011313c04', '5add9d5f9db58a0010d86a7b',
    // '58dd2be6a9ad9a0011efbf27', Prayuth T.
    // '5b13cdfa77286a00132b8606', Prayuth T.
    // '5b30aa4eb3cb30001194f5fb', Prayuth T.
    // '5b87a9b01b95c60012a4f4d5', Prayuth T.
    // '5ba0d18f33ea7900105bba24', Prayuth T.
    '5986da3deba3690011e6531f', '580f3ced2ec85f120006336c', '580f3faa2ec85f120006336f', '5857fce556a49c0011c5f262', '5805db5db762041600e9e3e9', '5cf4e4bc091cf70011689f1f', '580f3eca2ec85f120006336d', '5af0239d9569290011a8d7a7', '580f3fc6a2c5e61500208e27', '5ae73c26f09bb30011225cbb', '5ad9ba9a890fea00146f85e4', '5b1e5fde77286a00132b9b59', '5b1e48777f53c0001044e9a7']
  },
  staging: {
    isProduction: true,
    externalApiPath: 'https://api.staging.takemetour.com',
    apiPath: process.env.APIPATH || 'http://staging-api-service:3000',
    adminPath: 'http://staging.admin.takemetour.com',
    nexperiencePath: process.env.NEX_PATH || 'http://staging-nexperience:3000',
    dashboardPath: process.env.DASHBOARD_PATH || 'http://staging-redux-dashboard:3000',
    localtablePath: process.env.LOCAL_TABLE_PATH || 'http://staging-localtable:3000',
    biennalePath: process.env.BIENNALE_PATH || 'http://staging-biennale:3000',
    plusplusPath: process.env.PLUSPLUS_PATH || 'http://staging-plusplus-landing:3000',
    fruitMarketPath: process.env.FRUIT_MARKET_PATH || 'http://staging-fruit-market-frontend:3000',
    newNexPath: process.env.NEW_NEX_PATH || 'http://staging-the-next-takemetour:3000',
    socketPath: process.env.SOCKETPATH || 'http://staging-socketio-service:3000/ws',
    omisePublicKey: 'pkey_test_5nll2jx5x0xuyu6agqn',
    mediaPath: 'https://dja3e86j343dh.cloudfront.net',
    distPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-dev-assets',
    baseURL: {
      en: 'https://staging.takemetour.com',
      th: 'http://pachantiew.staging.takemetour.com',
      zh: 'http://zh.staging.takemetour.com'
    },
    letOtherJoinTrips: ['5c6144f8fedd2d001178d40b']
  }
}[(process.env.MOCK ? null : process.env.NODE_ENV) || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  baseURL: {
    en: (process.env.HOST || 'localhost') + ':' + (process.env.PORT || 3000),
    th: (process.env.HOST || 'th.localhost') + ':' + (process.env.PORT || 3000),
    zh: (process.env.HOST || 'zh.localhost') + ':' + (process.env.PORT || 3000)
  },
  externalApiPath: 'https://api.staging.takemetour.com',
  apiPath: process.env.APIPATH || 'https://api.staging.takemetour.com',
  adminPath: 'http://staging.admin.takemetour.com',
  nexperiencePath: process.env.NEX_PATH || 'https://staging.takemetour.com',
  dashboardPath: process.env.DASHBOARD_PATH || 'https://staging.takemetour.com',
  localtablePath: process.env.LOCAL_TABLE_PATH || 'http://staging.takemetour.com/localtable',
  biennalePath: process.env.BIENNALE_PATH || 'http://staging.takemetour.com/biennale',
  fruitMarketPath: process.env.FRUIT_MARKET_PATH || 'http://staging.takemetour.com/fruit-market',
  newNexPath: process.env.NEW_NEX_PATH || 'https://staging.takemetour.com',
  socketPath: process.env.SOCKETPATH || 'https://socketio.staging.takemetour.com/ws',
  app: {
    title: 'TakeMeTour',
    description: 'Book budget private tours with real locals',
    head: {
      titleTemplate: '%s | TakeMeTour - See Thailand through the local\'s eyes',
      meta: [{ name: 'description', content: 'Book budget private tours with real locals' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'TakeMeTour - See Thailand through the local\'s eyes' }, { property: 'og:image', content: 'theme/images/favicons/favicon-32x32.png' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Home' }, { property: 'og:description', content: 'Book budget private tours with real locals' }, { property: 'og:card', content: 'summary' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  },
  weibo: {
    zh: {
      oAuthUrl: 'https://api.weibo.com/oauth2/authorize',
      clientId: '1119250595',
      redirectUri: 'https://zh.takemetour.com/weibo/callback'
    }
  },
  lineNotify: {
    en: {
      oAuthUrl: 'https://notify-bot.line.me/oauth/authorize',
      clientId: 'sotqhrSF59ZwK8JjrUXyHL',
      redirectUri: 'https://www.takemetour.com/dashboard/settings'
    }
  },
  gaToken: 'UA-48143288-5',
  gaTokens: {
    en: 'UA-48143288-5',
    th: 'UA-48143288-5',
    zh: 'UA-48143288-5',
    au: 'UA-140710472-2'
  },
  firebase: {
    apiKey: 'AIzaSyBG5mcFlCf4UO3BD6aNQw2jO6PAtM_ByyA',
    messagingSenderId: '755898721010'
  },
  mediaPath: 'https://dja3e86j343dh.cloudfront.net',
  // omisePublicKey: 'pkey_test_527f2qc6zwgu8fj17o2',
  omisePublicKey: 'pkey_test_5lui5pyanups1l6ig27',
  mobileConnect: {
    redirectURI: 'https://www.takemetour.com/scripts/DiscoveryComplete.html'
  },
  mixpanel: {
    token: 'c5c372ecf4cd51d06a7824df7b5d7358'
  },
  facebookAppId: '512381822169849',
  googleClientId: '1087964454414-pnm60fbegh6cec6m0rvk9eienko254pj.apps.googleusercontent.com',
  wgProgramId: 'XXXX',
  wgEventId: 'YYYY',
  uiKitAssetPath: 'https://storage.googleapis.com/takemetour-uikit-asset-dev',
  isAustraliaSite: global.window ? global.window.IS_AUSTRALIA_SITE : process.env.COUNTRY === 'AU',
  firstBooking: 450,
  letOtherJoinTrips: ['5c6144f8fedd2d001178d40b'],
  tgthAffiliateId: 'tagthai'
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 37
// module chunks = 47